import { reactive, ref, computed, onMounted } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import * as validation from '@/util/validation'
import * as apiInquiry from '@/api/inquiry'
import { faBullseye } from '@fortawesome/pro-light-svg-icons'


// 無料トライアルお申し込みフォーム（メール送信）画面
export const getGroupIndex = () => {

  const group1 = reactive({
    email: '',
    email_check: '',

    error_email: '',
    error_email_check: '',

    // 送信中フラグ（二重送信防止用）
    isProcessing: false,
  
    // 「同意した上で進む」ボタンを押した場合
    onSubmitButtonCLicked: () => {

      // 入力チェック 
      let isError = false
      group1.error_email = ''
      group1.error_email_check = ''

      if (group1.email === '') {
        group1.error_email = '必須項目です。'
        isError = true
      } else if (!validation.checkHankaku(group1.email) || !validation.checkMaxLength(group1.email, 50)) {
        group1.error_email = '半角50文字以内で入力してください。'
        isError = true
      } else if (!validation.checkEmailFormat(group1.email)) {
        group1.error_email = '正しいメールアドレスを入力してください。'
        isError = true
      }

      if (group1.email_check === '') {
        group1.error_email_check = '必須項目です。'
        isError = true
      } else if (!validation.checkHankaku(group1.email_check) || !validation.checkMaxLength(group1.email_check, 50)) {
        group1.error_email_check = '半角50文字以内で入力してください。'
        isError = true
      } else if (!validation.checkEmailFormat(group1.email_check)) {
        group1.error_email_check = '正しいメールアドレスを入力してください。'
        isError = true
      }

      if (group1.error_email === '' && group1.error_email_check === '') {
        if (group1.email !== group1.email_check) {
          group1.error_email_check = 'メールアドレスが一致していません。'
          isError = true
        } 
      }

      if (isError) {
        // 入力エラーが存在した場合
        return false
      }

      // 二重送信防止
      if (group1.isProcessing) {
        const payload = {
          title: '二重送信エラー',
          text: '短い時間に複数回送信ボタンが押されました。\n二重送信の可能性があるため、2度目以降の処理を中断します。'
        }
        store.dispatch('common/showNotice', payload)
        return
      }

      // 送信中フラグ（二重送信防止用）をtrueに設定
      group1.isProcessing = true

      // 無料トライアルメール登録APIをコール
      const params = {}
      params.email = group1.email
      
      store.dispatch('common/showLoading')
      apiInquiry.registerFreeTrial(params)
        .then(response => {
        
          // 送信中フラグ（二重送信防止用）をfalseに設定
          group1.isProcessing = false

          if (response) {
            const { data } = response

            if (data) {
              const status = data.status ?? -1
              const errorMessage = data.error_message ?? ''
              
              if (status === 0) {
                // status=0: 成功
                router.push({ path: '/public/trial-application/complete' })
              } else {
                // エラーの場合
                store.dispatch('common/showNotice', { title: 'エラー', text: errorMessage })

              }
            }
          }
        })
        .finally(() => {
          store.dispatch('common/hideLoading')
        })
    }
  })

  return group1
}

// 無料トライアルお申し込みフォーム（メール送信完了）
export const getGroup2 = () => {

  const group2 = reactive({
    
  })

  return group2
}
